import * as React from "react";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LibraryMusicOutlinedIcon from "@mui/icons-material/LibraryMusicOutlined";

export default function CollectionBreadcrumbs(props) {
  return (
    <Stack direction="row" spacing={2}>
      <Breadcrumbs
        aria-label="breadcrumb"
        pt={3}
        separator={<NavigateNextIcon fontSize="small" />}
      >
        <Link style={{ textDecoration: "none" }} color="primary" href="/albums">
          <LibraryMusicOutlinedIcon
            style={{ color: "black" }}
          />{" "}
          Albums
        </Link>
        <Typography underline="hover" color="text.primary">
          {props.categoryTitle}
        </Typography>
      </Breadcrumbs>
    </Stack>
  );
}
